export default __webpack_public_path__ + "static/media/misc-drawerB-480w.019cecbd.png";